<template>
    <div>
        <!-- <h5>Face Recognetion</h5> -->
        <!-- <button type="button" @click="openCamera">Open Camera</button> -->
        <div id="liveView" class="videoView">
            <video id="webcamp" autoplay playsinline></video>
        </div>
    </div>
</template>

<script>
import { FaceDetector, FilesetResolver } from "@mediapipe/tasks-vision";

// import dataWasm from "@mediapipe/tasks-vision/wasm";
export default {
    data() {
        return {
            children: [],
            // dataWasm: require('@mediapipe/tasks-vision/wasm'),
            // dataModel: require("/blaze_face_short_range.tflite"),
        };
    },
    async mounted() {},

    async created() {},

    methods: {
        openCamera() {
            let constrain = {
                video: true,
            };
            if (navigator.getUserMedia) {
                navigator.mediaDevices.getUserMedia(constrain).then((stream) => {
                    const videoMedia = document.getElementById("webcamp");
                    videoMedia.srcObject = stream;
                    this.processResults();
                });
            }
        },
        async processResults() {
            const videoMedia = document.getElementById("webcamp");
            const vision = await FilesetResolver.forVisionTasks(
                // path/to/wasm/root
                "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm"
            );
            let lastVideoTime = -1;
            let startTimeMs = performance.now();
            let faceDetection = await FaceDetector.createFromOptions(vision, {
                baseOptions: {
                    modelAssetPath: window.location.origin + "/blaze_face_short_range.tflite",
                    delegate: "GPU",
                },
                runningMode: "VIDEO",
            });
            if (videoMedia.currentTime !== lastVideoTime) {
                lastVideoTime = videoMedia.currentTime;
                const detections = faceDetection.detectForVideo(videoMedia, startTimeMs).detections;
                this.displayVideoDetection(detections);
            }
            window.requestAnimationFrame(this.processResults);
        },
        displayVideoDetection(detections) {
            const liveView = document.getElementById("liveView");
            const videoMedia = document.getElementById("webcamp");

            for (let child of this.children) {
                liveView.removeChild(child);
                console.log(liveView);
            }
            this.children.splice(0);

            console.log(this.children);

            for (let detection of detections) {
                const p = document.createElement("p");
                p.innerText = "Confidence: " + Math.round(parseFloat(detection.categories[0].score) * 100) + "%";
                p.style =
                    "position: absolute;" +
                    "color: #fff;" +
                    "border: 1px solid #fff;" +
                    "left: " +
                    (videoMedia.offsetWidth - detection.boundingBox.width - detection.boundingBox.originX) +
                    "px;" +
                    "top: " +
                    (detection.boundingBox.originY - 30) +
                    "px; " +
                    "width: " +
                    (detection.boundingBox.width - 10) +
                    "px;";

                const highlighter = document.createElement("div");
                highlighter.setAttribute("class", "highlighter");
                highlighter.style =
                    "position: absolute;" +
                    "bacground: rgba(0, 255, 0, 0.25);" +
                    "border: 1px solid #fff;" +
                    "left: " +
                    (videoMedia.offsetWidth - detection.boundingBox.width - detection.boundingBox.originX) +
                    "px;" +
                    "top: " +
                    detection.boundingBox.originY +
                    "px;" +
                    "width: " +
                    (detection.boundingBox.width - 10) +
                    "px;" +
                    "height: " +
                    detection.boundingBox.height +
                    "px;";

                liveView.appendChild(highlighter);
                liveView.appendChild(p);
                this.children.push(highlighter);
                this.children.push(p);
                for (let keypoint of detection.keypoints) {
                    const keypointEl = document.createElement("span");
                    keypointEl.className = "key-point";
                    keypointEl.style.top = `${keypoint.y * videoMedia.offsetHeight - 3}px`;
                    keypointEl.style.left = `${videoMedia.offsetWidth - keypoint.x * videoMedia.offsetWidth - 3}px`;
                    liveView.appendChild(keypointEl);
                    this.children.push(keypointEl);
                }
            }
        },
    },
};
</script>

<style scoped>
.videoView {
    position: relative;
    width: 48%;
    margin: 2% 1%;
    cursor: pointer;
}
.videoView p {
    position: absolute;
    padding: 5px;
    background-color: #007f8b;
    color: #fff;
    border: 1px sholid rgba(255, 255, 255, 0.7);
    z-index: 2;
    font-size: 12px;
    margin: 0;
}

.highlighter {
    background: rgba(0, 255, 0, 0.25);
    border: 1px solid #fff;
    z-index: 1;
    position: absolute;
}

.key-point {
    position: absolute;
    z-index: 1;
    width: 3px;
    height: 3px;
    background-color: #ff0000;
    /* border: 1px solid #ffffff; */
    border-radius: 50%;
    display: block;
}
</style>
